import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../context/ThemeContext";
import ReservationStats from './Dashboard/ReservationStats';
import LatestReview from './Dashboard/LatestReview';
import RecentBooking from './Dashboard/RecentBooking';
import { get_Home_Page_Count } from '../../../store/actions/CommanAction';
import { useDispatch, useSelector } from 'react-redux';
import image from '../../../images/favicon1.png';
import totaluser from '../../../images/user.png';
import pujalist from '../../../images/favicon1.png'
import callimage from '../../../images/call.jfif';
import gemstoneimage from '../../../images/favicon1.png'
import { FaArrowUp } from 'react-icons/fa';
import { FaArrowDown } from 'react-icons/fa';
import { FaPhoneAlt } from 'react-icons/fa';
import { FaComment } from 'react-icons/fa';
import { FaOilCan } from 'react-icons/fa';
import { FaGem } from 'react-icons/fa';
import { FaStar } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import { HiUsers } from 'react-icons/hi';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { FaRegCalendarAlt } from "react-icons/fa";


import "react-datepicker/dist/react-datepicker.css";

import { get_UserData, } from "../../../store/actions/CommanAction";
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { setDataInElement } from 'ckeditor5';





const Home = () => {

	const UserData = useSelector((state) => state.feedBackReducer.UserData);
	const AstroData = useSelector((state) => state.feedBackReducer.AstroData);

	const dispatch = useDispatch()
	const navigate = useNavigate()

	const { changeBackground } = useContext(ThemeContext);
	const HomePageCount = useSelector((state) => state.feedBackReducer.HomePageCount);



	const [callchatstatus, setcallchatstatus] = useState('')
	const [searchTerm, setSearchTerm] = useState('');
	const [searchTerm1, setSearchTerm1] = useState('');
	const [selectedRange, setSelectedRange] = useState('Last 7 days');
	const [showDropdown, setShowDropdown] = useState(false);
	const [selectedOption, setSelectedOption] = useState("Today");
	const [loading, setloading] = useState(false);
	const [topastrologer, setTopastrologer] = useState([])
	const [callchatstatusdata, setcallchatstatusdata] = useState([])



	const filteredData = UserData?.filter(item =>
		item?.NickName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
		item?.MobileNo?.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const searchText = callchatstatus.trim().toLowerCase();



	
	const filteredData1 = !searchText
		? callchatstatusdata
		: callchatstatusdata?.filter(item =>
			(item?.Astroname || "").toLowerCase().includes(searchText) ||
			(item?.Type || "").toLowerCase().includes(searchText)
		);
	const TopAstrologer = async (CreatedDtTmFrom, CreatedDtTmTo) => {
		try {
			setloading(true)
			const payload = { CreatedDtTmFrom: CreatedDtTmFrom, CreatedDtTmTo: CreatedDtTmTo }
			const res = await AddUpdate("AstroWalletTransaction/TopAstrologer", payload)
			const rowdata = res && JSON?.parse(res?.data?.data);

			const finaldata = rowdata?.Table;

			setTopastrologer(finaldata)


		} catch (error) {

			console.log(error, "this is error")
		}
		finally {
			setloading(false)
		}
	}

	const callchatfunction = async (CreatedDtTmFrom, CreatedDtTmTo) => {
		try {
			setloading(true)
			const payload = { DeletedDateFrom: CreatedDtTmFrom, DeletedDateTo: CreatedDtTmTo, Type: "" }
			const res = await AddUpdate("WaitingList/GetData_StatusCount", payload)

			if (res) {


				const rowdata = res && JSON?.parse(res?.data?.data);

				const finaldata = rowdata?.Table;

				setcallchatstatusdata(finaldata)
			}
			else {
				setcallchatstatusdata([])
			}

		} catch (error) {

			console.log(error, "this is error")
		}
		finally {
			setloading(false)
		}
	}



	const formatDate = (date) => {
		return new Date(date).toISOString().split("T")[0];
	};

	const filteredDatas = topastrologer?.filter(item =>
		item?.DisplayName?.toLowerCase().includes(searchTerm1.toLowerCase()) ||
		item?.MainTopic?.toLowerCase().includes(searchTerm1.toLowerCase())
	);


	const options = [
		"Today",
		"Yesterday",
		"Last 7 Days",
		"Last 30 Days",
		"Last Month",
		"Custom Range"
	];


	const [startDate, setStartDate] = useState(new Date());
	const [endDate, setEndDate] = useState(new Date());
	const [dropdownOpen, setDropdownOpen] = useState(false);

	useEffect(() => {
		dispatch(get_Home_Page_Count(startDate, endDate));
		dispatch(get_UserData(setloading, "1", startDate, endDate))
		TopAstrologer(formatDate(startDate), formatDate(endDate))
		callchatfunction(formatDate(startDate), formatDate(endDate))

	}, [startDate, endDate]);
	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
	}, []);


	const handleOptionClick = (option) => {
		setSelectedOption(option);
		const today = new Date();
		let start, end;

		switch (option) {
			case "Today":
				start = end = today;
				break;
			case "Yesterday":
				start = end = new Date(today.setDate(today.getDate() - 1));
				break;
			case "Last 7 Days":
				start = new Date(today.setDate(today.getDate() - 6));
				end = new Date();
				break;
			case "Last 30 Days":
				start = new Date(today.setDate(today.getDate() - 29));
				end = new Date();
				break;
			case "Last Month":
				const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
				start = firstDayLastMonth;
				end = lastDayLastMonth;
				break;
			default:
				return;
		}

		setStartDate(start);
		setEndDate(end);


		dispatch(get_Home_Page_Count(start, end));
		dispatch(get_UserData(setloading, "1", start, end));
		TopAstrologer(formatDate(start), formatDate(end))
		callchatfunction(formatDate(startDate), formatDate(endDate))
		setDropdownOpen(false);
	};

const flatData = [];

filteredData1.forEach((item) => {
  let parsed = [];
  try {
    parsed = JSON.parse(item.Data || "[]");
  } catch {
    parsed = [];
  }

  parsed.forEach((p) => {
    flatData.push({
      AstroId: p.AstroId,
      Astroname: p.Astroname,
      Type: p.Type,
      CompletedCount: p.CompletedCount,
      WaitingCount: p.WaitingCount,
      OtherCount: p.OtherCount,
    });
  });
});





	return (
		<>
			<div className="row mt-3" >
				<div className="col-xl-12">
					<div className="row">
						<div className="col-xl-12">

							<div className="row justify-content-end">
								<div className="col-xl-12 text-right d-flex justify-content-end mb-3">
									<div className="position-relative d-inline-block" style={{ minWidth: 250 }}>
										<div className="input-group border rounded overflow-hidden" style={{ width: 'fit-content' }}>
											<span className="input-group-text bg-light border-0">
												<FaRegCalendarAlt color="#17a2b8" />
											</span>
											<button
												className="form-control text-start border-0"
												style={{
													cursor: "pointer",
													backgroundColor: "#fff",
													padding: "0.375rem 0.75rem",
													fontSize: "0.875rem",
													minWidth: "200px"
												}}
												onClick={() => setDropdownOpen(!dropdownOpen)}
											>
												{startDate.toLocaleDateString()} - {endDate.toLocaleDateString()}
											</button>
										</div>
										{dropdownOpen && (
											<ul
												className="list-group position-absolute mt-1 shadow-sm p-2"
												style={{ width: "100%", zIndex: 9999 }}
											>

												{selectedOption === "Custom Range" && (
													<div className="d-flex gap-2 ">
														<input
															type="date"
															value={startDate.toISOString().split("T")[0]}
															onChange={(e) => {
																const newStart = new Date(e.target.value);
																setStartDate(newStart);
																dispatch(get_Home_Page_Count(newStart, endDate));
																dispatch(get_UserData(setloading, "1", newStart, endDate));
																TopAstrologer(formatDate(newStart), formatDate(endDate));
																callchatfunction(formatDate(newStart), formatDate(endDate));
															}}
														/>

														<input
															type="date"
															value={endDate.toISOString().split("T")[0]}
															onChange={(e) => {
																const newEnd = new Date(e.target.value);
																setEndDate(newEnd);
																dispatch(get_Home_Page_Count(startDate, newEnd));
																dispatch(get_UserData(setloading, "1", startDate, newEnd));
																TopAstrologer(formatDate(startDate), formatDate(newEnd));
																callchatfunction(formatDate(startDate), formatDate(newEnd));
															}}
															min={startDate.toISOString().split("T")[0]}
														/>

													</div>
												)}

												{options.map((option) => (
													<li
														key={option}
														className="list-group-item list-group-item-action"
														onClick={() => handleOptionClick(option)}
														style={{
															cursor: "pointer",
															backgroundColor: option === selectedOption ? "#17a2b8" : "white",
															color: option === selectedOption ? "white" : "black"
														}}
													>
														{option}
													</li>
												))}
											</ul>
										)}
									</div>
								</div>
							</div>

							<div class="row g-4 mb-3">

								<div class="col-12 col-sm-6 col-xl-3">
									<div class="custom-card d-flex align-items-center gap-3 px-3 p-3">
										<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
											<img
												src="/brand/Astrologers.svg"
												alt="brand"
												className="img-fluid"
												style={{ width: '100%', height: '100%', objectFit: 'contain' }}
											/>
										</div>


										<div>
											<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/astrolist")} >Total Astrologer</div>
											<div class="subtitle" >{HomePageCount?.[0]?.Astrologer_Count}</div>
										</div>
									</div>
								</div>


								<div class="col-12 col-sm-6 col-xl-3">
									<div class="custom-card d-flex align-items-center gap-3 px-3 p-3">
										<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
											<img
												src="/brand/Users.svg"
												alt="brand"
												className="img-fluid"
												style={{ width: '100%', height: '100%', objectFit: 'contain' }}
											/>
										</div>
										<div>
											<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/userlist")}>Total Users</div>
											<div class="subtitle">{HomePageCount?.[0]?.User_count}</div>
										</div>
									</div>
								</div>


								<div class="col-12 col-sm-6 col-xl-3">
									<div class="custom-card d-flex align-items-center gap-3 px-3 p-3">
										<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
											<img
												src="/brand/Employee.svg"
												alt="brand"
												className="img-fluid"
												style={{ width: '100%', height: '100%', objectFit: 'contain' }}
											/>
										</div>
										<div>
											<div class="custom-title">Total Emp</div>
											<div class="subtitle">{HomePageCount?.[0]?.TotalEmp}</div>
										</div>
									</div>
								</div>


								<div class="col-12 col-sm-6 col-xl-3">
									<div class="custom-card d-flex align-items-center gap-3 px-3 p-3">
										<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
											<img
												src="/brand/PendingRequest.svg"
												alt="brand"
												className="img-fluid"
												style={{ width: '100%', height: '100%', objectFit: 'contain' }}
											/>
										</div>
										<div>
											<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/pendingapporeval")} >Pending Approval</div>
											<div class="subtitle"> {HomePageCount?.[0]?.PendingApproval}  Astrologers</div>
										</div>
									</div>
								</div>
							</div>






							<div className="row mb-3">
								<div className="col-xl-12">
									<div className="row g-4">

										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100 bg-white px-3 pt-3 pb-0 position-relative " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Call.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/CallHistory")}>CALL</div>
														<div class="subtitle">Apple, Inc</div>
													</div>
												</div>



												<div className="d-flex justify-content-between align-items-center mb-3">
													<h4 class="custom-stats-number">{HomePageCount?.[0]?.Callhistory}</h4>
													<span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg className="fill-current" width="13" height="12" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd"
																d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z"
																fill="currentColor" />
														</svg>
														11.01%
													</span>




												</div>

											</div>
										</div>


										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100 bg-white px-3 pt-3 position-relative " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Chat.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/ChatHistory")}>CHAT</div>
														<div class="subtitle">Paypal, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number">{HomePageCount?.[0]?.TodayChat_Count}</h5>
													<span className="badge custom-dark-bg custom-dark-text px-2 py-1 d-flex align-items-center gap-1">
														<svg width="12" height="12" fill="currentColor" viewBox="0 0 12 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M5.31462 10.3761C5.45194 10.5293 5.65136 10.6257 5.87329 10.6257C6.0663 10.6259 6.25845 10.5527 6.40505 10.4062L9.40514 7.4082C9.69814 7.11541 9.69831 6.64054 9.40552 6.34754C9.11273 6.05454 8.63785 6.05438 8.34486 6.34717L6.62329 8.06753V1.875C6.62329 1.46079 6.28751 1.125 5.87329 1.125C5.45908 1.125 5.12329 1.46079 5.12329 1.875V8.06422L3.40516 6.34719C3.11218 6.05439 2.6373 6.05454 2.3445 6.34752C2.0517 6.64051 2.05185 7.11538 2.34484 7.40818L5.31462 10.3761Z" />
														</svg>
														9.05%
													</span>
												</div>

											</div>
										</div>

										{/* Online Pooja */}
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100  bg-white px-3 pt-3  position-relative " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Puja.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/PujaListFilter")}>Pooja</div>
														<div class="subtitle">Microsoft, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number">{HomePageCount?.[0]?.online_puja}</h5>
													<span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg width="13" height="12" fill="currentColor" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z" />
														</svg>
														5.22%
													</span>
												</div>

											</div>
										</div>

										{/* Gemstones */}
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100  bg-white px-3 pt-3 position-relative pb-0 " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center  mb-4 gap-2">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Gemstone.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/GemstoneListFilter")}>Gemstones</div>
														<div class="subtitle">Google, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number">{HomePageCount?.[0]?.Gemstone}</h5>
													<span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg width="13" height="12" fill="currentColor" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z" />
														</svg>
														6.47%
													</span>
												</div>

											</div>
										</div>
									</div>

								</div>
							</div>




							<div className="row mb-3">
								<div className="col-xl-12">
									<div className="row g-4">
										{/* CALL */}
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100 bg-white px-3 pt-3  position-relative pb-0  " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Income.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div><div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/IncomeTransaction")} >Income</div>
														<div class="subtitle">Apple, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h4 class="custom-stats-number" >{HomePageCount?.[0]?.Income}</h4>

													<span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg className="fill-current" width="13" height="12" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd"
																d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z"
																fill="currentColor" />
														</svg>
														11.01%
													</span>

												</div>

											</div>
										</div>

										{/* CHAT */}
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100  bg-white px-3 pt-3  position-relative pb-0 " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Expenses.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>
													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/AddExpenseEntry")}>Expenses</div>
														<div class="subtitle">Paypal, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number">{HomePageCount?.[0]?.Expenses}</h5>
													<span className="badge custom-dark-bg custom-dark-text px-2 py-1 d-flex align-items-center gap-1">
														<svg width="12" height="12" fill="currentColor" viewBox="0 0 12 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M5.31462 10.3761C5.45194 10.5293 5.65136 10.6257 5.87329 10.6257C6.0663 10.6259 6.25845 10.5527 6.40505 10.4062L9.40514 7.4082C9.69814 7.11541 9.69831 6.64054 9.40552 6.34754C9.11273 6.05454 8.63785 6.05438 8.34486 6.34717L6.62329 8.06753V1.875C6.62329 1.46079 6.28751 1.125 5.87329 1.125C5.45908 1.125 5.12329 1.46079 5.12329 1.875V8.06422L3.40516 6.34719C3.11218 6.05439 2.6373 6.05454 2.3445 6.34752C2.0517 6.64051 2.05185 7.11538 2.34484 7.40818L5.31462 10.3761Z" />
														</svg>
														9.05%
													</span>
												</div>

											</div>
										</div>

										{/* Online Pooja */}
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100  bg-white px-3 pt-3  position-relative pb-0 " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/Tax.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title">GST / Tax</div>
														<div class="subtitle">Tesla, Inc</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number"> {HomePageCount?.[0]?.GSTAmount}</h5>
													<span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg width="13" height="12" fill="currentColor" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z" />
														</svg>
														11.01%
													</span>
												</div>
											</div>
										</div>

										
										<div className="col-12 col-sm-6 col-xl-3">
											<div className="custom-card h-100 bg-white px-3 pt-3   position-relative pb-0 " style={{ borderRadius: '12px' }}>
												<div className="d-flex align-items-center mb-4 gap-3">
													<div class="flex-shrink-0">
														<div className="flex-shrink-0" style={{ width: '40px', height: '40px' }}>
															<img
																src="/brand/BillPay.svg"
																alt="brand"
																className="img-fluid"
																style={{ width: '100%', height: '100%', objectFit: 'contain' }}
															/>
														</div>

													</div>
													<div>
														<div class="custom-title" style={{ cursor: "pointer" }} onClick={() => navigate("/astrologermobileno")} >Astrologer MobileNo SendCount</div>
														
														<div class="subtitle">Unauthorized Contact Sharing</div>

													</div>
												</div>


												<div className="d-flex justify-content-between align-items-center mb-3">
													<h5 class="custom-stats-number">{HomePageCount?.[0]?.AstroDetailsendChatCount}</h5>
													{/* <span className="badge custom-badge-success px-2 py-1 d-flex align-items-center gap-1">
														<svg width="13" height="12" fill="currentColor" viewBox="0 0 13 12">
															<path fillRule="evenodd" clipRule="evenodd" d="M6.06462 1.62393C6.20193 1.47072 6.40135 1.37432 6.62329 1.37432C6.81631 1.37415 7.00845 1.44731 7.15505 1.5938L10.1551 4.5918C10.4481 4.88459 10.4483 5.35946 10.1555 5.65246C9.86273 5.94546 9.38785 5.94562 9.09486 5.65283L7.37329 3.93247V10.125C7.37329 10.5392 7.03751 10.875 6.62329 10.875C6.20908 10.875 5.87329 10.5392 5.87329 10.125V3.93578L4.15516 5.65281C3.86218 5.94561 3.3873 5.94546 3.0945 5.65248C2.8017 5.35949 2.80185 4.88462 3.09484 4.59182L6.06462 1.62393Z" />
														</svg>
														
													</span> */}
												</div>

											</div>
										</div>
									</div>

								</div>
							</div>




						</div>

						<div className='col-xl-12'>
							<div className='row g-4'>
								<div className='col-lg-6 col-md-12 mb-4'>
									<div className='card shadow-sm ' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
										<div className="card-body">
											<div className="d-flex justify-content-between align-items-center mb-3">
												<h4 className="mb-0 fs-20">Newly Users</h4>
												<input
													type="text"
													placeholder="Search..."
													className="form-control w-25"
													value={searchTerm}
													onChange={(e) => setSearchTerm(e.target.value)}
												/>
											</div>

											<div style={{ maxHeight: "300px", overflowY: "auto" }}>
												<table className="table">

													<thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
														<tr>
															<th>Full Name</th>
															<th>Mobile No.</th>
															<th>Date</th>
															<th>Wallet Amount</th>
														</tr>
													</thead>

													<tbody>
														{filteredData?.length > 0 ? (
															filteredData.map((employee, key) => (
																<tr key={employee?.key}>
																	<td>{employee?.NickName}</td>
																	<td>{employee?.MobileNo}</td>
																	<td>
																		{employee?.CreatedTime
																			? new Date(employee.CreatedTime).toLocaleDateString("en-CA")
																			: ""}
																	</td>
																	<td>{employee?.WalletAmt}</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan="4" className="text-center text-muted">
																	No Records Found
																</td>
															</tr>
														)}
													</tbody>

												</table>
											</div>

											<div className="d-flex justify-content-between align-items-center">
												<p className="mb-0 text-muted">Showing {filteredData?.length} of {UserData?.length} entries</p>
												<button className="btn btn-sm btn-outline-primary" onClick={() => navigate('/userlist')}>
													View All
												</button>
											</div>
										</div>
									</div>
								</div>



								<div className='col-lg-6 col-md-12 mb-4'>
									<div className='card shadow-sm' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
										<div className="card-body">
											<div className="d-flex justify-content-between align-items-center mb-3">
												<h5 className="mb-0 fs-20">Top Astrologer</h5>
												<input
													type="text"
													placeholder="Search..."
													className="form-control w-25"
													value={searchTerm1}
													onChange={(e) => setSearchTerm1(e.target.value)}
												/>
											</div>

											<div style={{ maxHeight: "250px", overflowY: "auto" }}>
												<table className="table align-middle mb-3">

													<thead
														style={{
															backgroundColor: "#f4f6f9",
															position: "sticky",
															top: 0,
															zIndex: 1
														}}
													>
														<tr>
															<th className="text-secondary fw-semibold">Full Name</th>
															<th className="text-secondary fw-semibold">Minutes</th>
															<th className="text-secondary fw-semibold">Type</th>
														</tr>
													</thead>

													<tbody>
														{filteredDatas?.length > 0 ? (
															filteredDatas.map((employee) => (
																<tr key={employee?.AstroID}>
																	<td>{employee?.DisplayName}</td>

																	<td>
																		<div className="d-flex flex-column">
																			<span>{employee?.TotalMinutes} mins</span>
																		</div>
																	</td>

																	<td>{employee?.MainTopic}</td>
																</tr>
															))
														) : (
															<tr>
																<td colSpan="3" className="text-center text-muted">
																	No Records Found
																</td>
															</tr>
														)}
													</tbody>

												</table>
											</div>

											<div className="d-flex justify-content-between align-items-center">
												<p className="mb-0 text-muted">
													{/* Showing {filteredDatas?.length} of {AstroData?.length} entries */}
													Showing {filteredDatas?.length} entries
												</p>
												<button className="btn btn-sm btn-outline-primary" onClick={() => navigate('/astrolist')}>
													View All
												</button>
											</div>
										</div>
									</div>
								</div>

								<div className='col-lg-6 col-md-12 mb-4'>
									<div className='card shadow-sm ' style={{ border: "1px solid #e5e7eb", borderRadius: '12px' }}>
										<div className="card-body">
											<div className="d-flex justify-content-between align-items-center mb-3">
												<h4 className="mb-0 fs-20">Call/Chat Status</h4>
												<input
													type="text"
													placeholder="Search..."
													className="form-control w-25"
													value={callchatstatus}
													onChange={(e) => setcallchatstatus(e.target.value)}
												/>
											</div>

											<div style={{ maxHeight: "300px", overflowY: "auto" }}>
												<table className="table">

													<thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
														<tr>
															<th>Astrologer Name</th>
															<th>Type</th>
															<th>CompletCount</th>
															<th>WaitingCount</th>
															<th>OtherCount</th>
														</tr>
													</thead>

													<tbody>
  {flatData.length > 0 ? (
    Object.values(
      flatData.reduce((acc, item) => {
        const key = item.AstroId;

        if (!acc[key]) {
          acc[key] = {
            name: item.Astroname,
            rows: [],
          };
        }

        acc[key].rows.push(item);
        return acc;
      }, {})
    )
      .slice(0, 5)
      .map((group, index) =>
        group.rows.map((row, i) => (
          <tr key={`${index}-${i}`}>
            {i === 0 && (
              <td
                rowSpan={group.rows.length}
                style={{
                  verticalAlign: "middle",
                  fontWeight: "600",
                }}
              >
                {group.name}
              </td>
            )}

            <td style={{ textTransform: "capitalize" }}>
              {row.Type}
            </td>
            <td>{row.CompletedCount}</td>
            <td>{row.WaitingCount}</td>
            <td>{row.OtherCount}</td>
          </tr>
        ))
      )
  ) : (
    <tr>
      <td colSpan="5" className="text-center">
        No Records Found
      </td>
    </tr>
  )}
</tbody>

												</table>
											</div>

											<div className="d-flex justify-content-between align-items-center">
												<p className="mb-0 text-muted">Showing {filteredData1?.length}  entries</p>

<button className="btn btn-sm btn-outline-primary" onClick={() => navigate('/callchatstatus')}>
													View All
												</button>
											</div>
										</div>
									</div>
								</div>



							</div>

						</div>



						<div className="col-xl-12">
							<div className="row">

								<div className="col-xl-12">
									<div className="row">
										<div className="col-xl-12">
											<ReservationStats />
										</div>


										<div className="col-xl-12">
											<div className="card">
												<div className="card-body">
													<div className="row">
														<div className="col-xl-3 col-sm-3 col-6 mb-4 col-xxl-6">
															<div className="text-center">
																<h3 className="fs-28 font-w600">{HomePageCount?.[0]?.Astrologer_Count}</h3>
																<span className="fs-16">Total Astrologers</span>
															</div>
														</div>
														<div className="col-xl-3 col-sm-3 col-6 mb-4 col-xxl-6">
															<div className="text-center">
																<h3 className="fs-28 font-w600">{HomePageCount?.[0]?.User_count}</h3>
																<span className="fs-16">Total Users</span>
															</div>
														</div>
														<div className="col-xl-3 col-sm-3 col-6 mb-4 col-xxl-6">
															<div className="text-center">
																<h3 className="fs-28 font-w600">{HomePageCount?.[0]?.TodayChat_Count}</h3>
																<span className="fs-16">Total Chats</span>
															</div>
														</div>
														<div className="col-xl-3 col-sm-3 col-6 mb-4 col-xxl-6">
															<div className="text-center">
																<h3 className="fs-28 font-w600">{HomePageCount?.[0]?.Callhistory}</h3>
																<span className="fs-16 wspace-no">Total Calls</span>
															</div>
														</div>

													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-12">
							<div className="card">
								<div className="card-header border-0 pb-0">
									<h4 className="fs-20">Latest Review by Customers</h4>
								</div>
								<div className="card-body pt-0">
									{/* <LatestReview /> */}
									<LatestReview startDate={startDate} endDate={endDate} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div >
		</>
	)
}
export default Home;